<template>
  <div class="hello">
    <figure class="image is-128x128">
      <img alt="Spifi Macs Logo" src="../assets/logo.png">
    </figure>
    <h1 class="title">Welcome to Spifi Macs</h1>
    <h2 class="subtitle">
      {{ msg }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'WelcomeMessage',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
figure.image.is-128x128 {
    margin-left: auto;
    margin-right: auto;
}
</style>
